import { Component, inject, signal } from '@angular/core';
import { LanguageService } from '../core/language';

@Component({
  selector: 'app-faqs',
  templateUrl: './faqs.html',
})
export class FaqsPage {
  protected readonly lang = inject(LanguageService);
  protected readonly open = signal(0);

  protected toggle(index: number): void {
    this.open.update((current) => (current === index ? -1 : index));
  }
}
